// Wolfhound FAQ accordion
// Handles click and keyboard (Enter/Space) toggling with full ARIA support.
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.faq-question').forEach(function (question) {
    // Make focusable and announce role
    question.setAttribute('role', 'button');
    question.setAttribute('tabindex', '0');

    var parent = question.parentElement;
    var answer = parent.querySelector('.faq-answer');

    // Set initial ARIA state
    var expanded = parent.classList.contains('active');
    question.setAttribute('aria-expanded', String(expanded));
    if (answer) {
      answer.setAttribute('role', 'region');
      answer.setAttribute('aria-hidden', String(!expanded));
    }

    function toggle() {
      var isActive = parent.classList.toggle('active');
      question.setAttribute('aria-expanded', String(isActive));
      if (answer) {
        answer.setAttribute('aria-hidden', String(!isActive));
      }
    }

    question.addEventListener('click', toggle);

    question.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggle();
      }
    });
  });
});
